import { render, staticRenderFns } from "./appointWait.vue?vue&type=template&id=fb1159f6&scoped=true"
import script from "./appointWait.vue?vue&type=script&lang=js"
export * from "./appointWait.vue?vue&type=script&lang=js"
import style0 from "./appointWait.vue?vue&type=style&index=0&id=fb1159f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1159f6",
  null
  
)

export default component.exports